var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-contact-pro",attrs:{"id":"app"}},[_c('ContactProDropdownNavigationBar'),_vm._v(" "),_c('main',[_c('nuxt')],1),_vm._v(" "),_c('Footer',{staticClass:"mt-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }